import pick from 'lodash-es/pick';
import isEqual from 'lodash-es/isEqual';
import { createAction } from 'redux-actions';
import reportError from 'ha/helpers/bugsnag/reportError';
import { Actions } from '../constants';
import { getUniversitiesRequestId, getPreviousParams } from '../selectors';

const queryParams = ['location', 'latitude', 'longitude'];

const flow = {
  start: createAction(Actions.LOAD_UNIVERSITIES_START),
  done: createAction(Actions.LOAD_UNIVERSITIES_DONE),
};

export default reqParams => (dispatch, getState, services) => {
  const state = getState();

  const previousParams = pick(getPreviousParams(state), queryParams);

  if (isEqual(pick(reqParams, queryParams), previousParams)) {
    return Promise.resolve();
  }

  // For the initial request, we don't have latitude or longitude, so we need to query.
  const params =
    reqParams.latitude && reqParams.longitude
      ? { latitude: reqParams.latitude, longitude: reqParams.longitude }
      : { query: reqParams.location };

  const requestId = Date.now();

  dispatch(flow.start(requestId));

  return services.apiV2
    .getPois({
      type: 'university',
      singleGeoname: true,
      ...params,
    })
    .then(response => {
      if (getUniversitiesRequestId(getState()) !== requestId) {
        // Query is not the last one. Dismiss results.
        return;
      }

      dispatch(flow.done(response.data.pois));
    })
    .catch(error => {
      reportError('Load universities error', { metaData: { error } });
      dispatch(flow.done([]));
    });
};
